export default {
  welcome: {
    your_language: 'La tua lingua',
    language_to_learn: 'Lingua che vuoi imparare',
    start_learning: 'Inizia a imparare',
    how_does_this_work: 'Come funziona?',
    welcome_1: 'Benvenuto su JAALUU',
    welcome_2: 'Qui puoi imparare le lingue',
    welcome_3: 'Leggi testi o guarda video con sottotitoli',
    welcome_4: 'Clicca su una parola per traduzioni, esempi e definizioni',
    main_teaser: 'Migliora le tue competenze linguistiche - facilmente e gratuitamente',
    hero_headline:
      "Smetti di memorizzare liste. Inizia a parlare in modo fluente grazie all'immersione basata sull'IA",
    hero_subheadline:
      'Jaaluu utilizza contenuti reali, conversazioni personalizzate con un chatbot e la ripetizione dilazionata per aiutarti a padroneggiare una nuova lingua in pochi minuti al giorno.',
    hero_cta: 'Inizia gratis',
    select_language_and_start: 'Seleziona la lingua e inizia',
    how_to_title: 'Leggi testi, libri, notizie o guarda video',
    how_to_text: 'Puoi scegliere tra una varietà di testi, libri, notizie o video',
    click_on_word_title: 'Traduzione automatica, esempi e definizioni',
    click_on_word_text:
      'Clicca su qualsiasi parola per traduzione automatica, frasi di esempio e definizioni. Puoi anche tradurre frasi intere automaticamente o collegare parole con immagini e creare reti di parole.',
    listen_title: 'Ascolta parole e testi',
    listen_text: 'Puoi ascoltare qualsiasi parola, frase o testo intero e praticare la pronuncia',
    conversations_title: 'Pratica conversazioni',
    conversations_text:
      'Puoi praticare conversazioni parlando con un chatbot virtuale. Devi risolvere compiti come: `Ordina cibo in un ristorante` o `Chiedi indicazioni.`',
    writing_title: 'Ortografia',
    writing_text_1: "Pratica l'ortografia scrivendo testi",
    writing_text_2:
      'I tuoi testi verranno controllati per errori ortografici, contenuto e grammatica.',
    texts_and_videos_title: 'Trova il tuo livello',
    texts_and_videos_text:
      'Puoi scegliere tra frasi semplici e testi per bambini, notizie, articoli di Wikipedia o libri, a seconda di ciò che ti si addice di più',
    srs_title: 'Ripeti e allena il vocabolario',
    srs_text_1:
      'Puoi salvare qualsiasi parola o intera frase tra i preferiti per ripetere in seguito',
    srs_text_2:
      'Allena il tuo vocabolario con flashcards ed esercizi semplici, e monitora i tuoi progressi',
    srs_text_3:
      'Il sistema di ripetizione SRS ti aiuta ad imparare in modo più efficace ripetendo le parole al momento giusto',
    own_text_title: 'Vocabolario specializzato',
    own_text_text:
      'Puoi creare un testo su un argomento specifico per imparare vocabolario specializzato. Puoi anche creare testi contenenti parole che desideri imparare.',
    wordmap_title: 'Reti di parole',
    wordmap_text_1: 'Puoi creare reti di parole e collegare parole con frasi semplici',
    wordmap_text_2:
      'Le schede delle parole possono essere salvate come preferite, per permettere una facile ripetizione e allenamento',
    sayings_title: 'Modi di dire',
    sayings_text:
      'Qui troverai frasi e modi di dire comunemente usati, suddivisi in categorie. Puoi monitorare i tuoi progressi e continuare a svilupparti in modo strutturato.',
    details: 'Dettagli',
    details_text_and_videos_title:
      'Scopri Jaaluu – La tua chiave per un apprendimento linguistico veloce ed efficace!',
    details_text_and_videos_text:
      'Jaaluu ti offre una vasta gamma di testi e video per migliorare il tuo livello linguistico. La piattaforma è ideale se riesci già a comprendere parole e frasi semplici. Per i principianti, ci sono frasi e modi di dire semplici, testi per bambini, dizionari e video per un inizio facile. Per i livelli avanzati, ci sono notizie, articoli di Wikipedia, libri e video interessanti per una comprensione più profonda, o conversazioni interattive con chatbot. Inoltre, puoi allenare la tua ortografia e ricevere suggerimenti per migliorare gli errori di ortografia, contenuto e grammatica.',
    details_click_on_words_title:
      'Imparare il vocabolario diventa facile: Veloce, interattivo e sostenibile!',
    details_click_on_words_text:
      'Imparare il vocabolario può essere noioso perché cercare parole e definizioni richiede molto tempo. Jaaluu risolve questo problema: basta cliccare su una parola per ottenere traduzioni, frasi di esempio, definizioni e spiegazioni istantaneamente. Questo ti fa risparmiare tempo e ti aiuta ad imparare più velocemente e in modo più efficace!',
    details_listen_title:
      'Ascolta e pratica: Ascolta parole, frasi e testi per migliorare le tue competenze linguistiche!',
    details_listen_text:
      'Puoi ascoltare tutto – qualsiasi parola, frase o anche testi interi. Basta riprodurre e ascoltare! Questa funzione ti aiuta a praticare la corretta pronuncia e a migliorare la comprensione orale. Puoi anche ascoltare conversazioni e sviluppare una percezione per la comunicazione naturale. Perfetto per interiorizzare il vocabolario e rafforzare le tue competenze linguistiche nelle situazioni quotidiane.',
    details_conversations_title:
      'Allenamento linguistico pratico: Conversazioni realistiche per la vita quotidiana!',
    details_conversations_text:
      'Con Jaaluu, puoi praticare conversazioni realistiche con un chatbot e prepararti per situazioni tipiche della vita quotidiana. Ad esempio, puoi ordinare cibo in un ristorante e pagare il conto, oppure chiedere indicazioni. Oppure, puoi fare una chiacchierata con il tuo nuovo collega nel tuo primo giorno di lavoro. Le tue frasi verranno analizzate automaticamente per darti un feedback diretto e migliorare le tue competenze linguistiche. In questo modo, ti alleni in modo pratico ed efficace per conversazioni reali!',
    details_writing_title:
      'Pratica di scrittura per la vita quotidiana: Migliora le tue competenze con compiti realistici!',
    details_writing_text:
      'Puoi praticare la scrittura affrontando piccoli compiti realistici, come scrivere lettere di candidatura o di reclamo. Il tuo testo verrà poi analizzato automaticamente e riceverai un feedback diretto su ortografia, contenuto e grammatica. In questo modo, migliori le tue competenze nella scrittura e sei ben preparato per la vita quotidiana!',
    details_srs_title:
      'Apprendimento efficace del vocabolario con SRS: Ripetizioni automatiche e analisi personalizzate dei progressi!',
    details_srs_text:
      "Con il sistema SRS (Spaced Repetition System), puoi imparare e ripetere il vocabolario in modo efficace. Questo sistema ti ricorda quando ripetere le parole per conservarle a lungo termine. SRS si basa sul metodo scientifico secondo cui ripetere a intervalli determinati rafforza la memoria. Riceverai anche statistiche sul progresso di apprendimento di ogni parola e sulla tua percentuale di successo, così da poter concentrarti sui tuoi punti deboli e sapere sempre come stai progredendo nell'apprendimento del vocabolario.",
    details_own_text_title:
      'Apprendimento personalizzato: Crea testi personalizzati per esercizi mirati di vocabolario e argomenti!',
    details_own_text_text:
      "Con Jaaluu, puoi facilmente creare i tuoi testi in aree su cui desideri concentrarti. Descrivi l'area o il vocabolario che vuoi imparare, e riceverai un testo da leggere e praticare. In questo modo, puoi concentrarti su argomenti o vocabolario specifici ed espandere la tua conoscenza nell'area che ti interessa. Questo approccio personalizzato ti aiuta ad imparare in modo più efficace e preciso! Inoltre, puoi creare testi che contengono tutto il vocabolario che vuoi rivedere. In questo modo, impari e rivedi il vocabolario nel contesto, facilitandone la memorizzazione.",
    details_wordmap_title:
      'Schede delle parole: Collega la tua conoscenza e ricorda le parole con facilità!',
    details_wordmap_text:
      'Puoi creare schede delle parole che ti aiutano a collegare le parole e ricordarle in modo più efficace. Aggiungi parole e frasi interattivamente alla tua scheda delle parole e amplia gradualmente il tuo vocabolario. Questo crea e rafforza le connessioni nel tuo cervello e costruisce associazioni in modo giocoso. In questo modo, rafforzi la tua comprensione linguistica – in modo sostenibile!',
    details_paste_text_title:
      'Usa i tuoi testi: Incolla il tuo contenuto per imparare con attenzione!',
    details_paste_text_text:
      'Con Jaaluu, puoi anche incollare i tuoi testi per utilizzarli per la pratica. Questo ti permette di lavorare con il tuo materiale e allenare il tuo vocabolario in contesti reali.',
    explore_more: 'Scopri altro su Jaaluu',
    site_also_available: 'Il sito è disponibile anche in',
    which_languages_title: 'Quali lingue posso imparare?',
    which_languages_text:
      'Qui puoi imparare inglese, spagnolo, tedesco, francese, portoghese, russo e polacco. Seleziona semplicemente la lingua che vuoi imparare e sei pronto per partire!'
  },
  intro: {
    your_level: 'Qual è il tuo livello di lingua?',
    beginner_explained: 'Puoi leggere frasi semplici',
    intermediate_explained: 'Puoi leggere testi e articoli semplici',
    advanced_explained: 'Puoi leggere testi più complessi',
    your_cefr_level: 'Il tuo livello CEFR è',
    lets_start: 'Con cosa vorresti iniziare?',
    intermediate_options: {
      simple_texts: 'Leggere testi',
      simple_articles: 'Leggere articoli',
      sayings: 'Imparare modi di dire',
      simple_phrases: 'Leggere frasi tipiche',
      klexikon: 'Leggere Klexikon (Enciclopedia per bambini)'
    },
    advanced_options: {
      news: 'Leggere notizie',
      wikipedia: 'Leggere articoli',
      books: 'Leggere libri',
      conversations: 'Praticare conversazioni',
      writing: 'Praticare la scrittura'
    }
  },
  languages: {
    de: 'Tedesco',
    en: 'Inglese',
    es: 'Spagnolo',
    fr: 'Francese',
    it: 'Italiano',
    pt: 'Portoghese',
    ru: 'Russo',
    zh: 'Cinese',
    pl: 'Polacco'
  },
  general: {
    close: 'Chiudi',
    home: 'Home',
    beginner: 'Principiante',
    intermediate: 'Intermedio',
    advanced: 'Avanzato',
    search: 'Cerca',
    what_to_read: 'Cosa vorresti leggere?',
    search_imperative: 'Cerca',
    translate: 'Traduci',
    what_you_want_to_translate: 'Cosa vuoi tradurre da {from} a {to}?',
    word_not_found: 'La parola "{word}" non sembra esistere.',
    similar_words_found: 'Ho trovato le parole più simili:',
    settings: 'Impostazioni',
    vocabulary: 'Vocabolario',
    most_important_words: '{n} parole più importanti',
    learn_most_important_words: 'Impara le 500 parole più importanti',
    continue_with_word: 'Continua con la parola {n}',
    jokes: 'Barzellette',
    n_jokes: '{n} barzellette',
    learn_jokes: 'Impara 200 barzellette',
    continue_with_joke: 'Continua con la barzelletta {n}',
    shorts: 'Testi brevi',
    articles: 'Articoli',
    feeds: 'Notizie',
    videos: 'Video',
    read: 'Leggi',
    view: 'Guarda',
    listen: 'Ascolta',
    save: 'Salva',
    more: 'altro',
    back: 'Indietro',
    next: 'Avanti',
    continue_with_sentence: 'Continua con la frase {sentenceIdx}',
    easy: 'Facile',
    medium: 'Medio',
    hard: 'Difficile',
    all: 'Tutti',
    level: 'Livello',
    font_size: 'Dimensione del carattere',
    language: 'Lingua',
    send: 'Invia',
    image: 'Immagine',
    wordmap: 'Mappa delle parole',
    open: 'Apri',
    add: 'Aggiungi',
    question: 'Domanda',
    start: 'Inizia',
    continue: 'Continua',
    words: 'Parola | Parole',
    points: 'Punto | Punti',
    repeat: 'Ripetere',
    test: 'Testare',
    nothing_found: 'Niente trovato',
    skip: 'Salta',
    congratulations: 'Congratulazioni',
    well_done: 'Ben fatto!',
    try_again: 'Riprova',
    finish: 'Termina',
    total: 'Totale',
    synapsis_score: 'Synapsis Score',
    synapsis_milestone: 'Traguardo del punteggio sinaptico! Nuovo punteggio: {score}',
    fun_facts: 'Curiosità su {country}',
    fun_facts_missing_points: 'Punti per la prossima curiosità su {country}',
    fun_facts_previous: 'Curiosità precedenti ({count})',
    fun_fact_unlocked: 'Ora puoi vedere una nuova curiosità su {country}',
    finished_units: 'Unità | Unità',
    finished_course_chapters: 'Capitolo del corso | Capitoli del corso',
    grammar_chapters: 'Capitolo di grammatica | Capitoli di grammatica',
    completed: 'Completato',
    turn: 'Girare'
  },
  app_bar: {
    search_in_foreign_language: 'Cerca in lingua straniera',
    menu: 'Menu'
  },
  category: {
    chapter: 'Capitolo',
    learn_most_common_pre: 'Impara i più comuni',
    learn_most_common_post: 'da molte categorie diverse',
    or_choose_a_category: 'Scegli una categoria:',
    chapter_end: 'Hai raggiunto la fine di questo capitolo!',
    phrases: 'Frasi',
    sayings: 'Detti',
    simple_texts: 'Testi',
    conversations: 'Conversazioni',
    write: 'Scrittura',
    course: 'Corso'
  },
  favorites: {
    favorites: 'Preferiti',
    word: 'Parola',
    sentence: 'Frase',
    sentences: 'Frasi',
    texts: 'Testi',
    wordmaps: 'Mappe delle parole',
    saved: 'Salvato',
    title: 'Titolo',
    type: 'Tipo',
    no_favorites_found: 'Nessun preferito trovato',
    filtered_by: 'filtrato per',
    train: 'Allenamento',
    train_words: 'Allenare {wordCount} parole',
    notify_me_srs: 'Avvisami di ripetere il vocabolario con SRS',
    action_sounds: 'Suoni azione',
    srs_level: 'Livello SRS',
    success_rate: 'Tasso di successo',
    word_type: 'Tipo di parola',
    translation: 'Traduzione',
    context: 'Contesto',
    last_seen: 'Ultima volta visto',
    next_review: 'Prossima revisione',
    short_story: 'Racconto breve',
    success_level_up: 'Parola spostata al livello {level}',
    success_level_up_celebrate: 'La parola {word} è passata al livello successivo!',
    what_is_srs: "Cos'è SRS?",
    srs_short:
      'SRS è un sistema di ripetizione spaziale. Ti aiuta a ricordare meglio le parole ripetendole al momento giusto.',
    srs_long:
      'Il sistema si basa sul principio che più spesso ripeti una parola, meglio la ricordi. Gli intervalli tra le ripetizioni sono determinati dal sistema. Se ricordi bene una parola, gli intervalli diventano più lunghi. Se hai difficoltà, gli intervalli diventano più brevi. In questo modo puoi imparare le parole in modo più efficiente.',
    srs_intervals: 'Gli intervalli di {nIntervals} sono: {intervals} giorni.',
    when_does_a_word_move: 'Quando una parola passa al livello successivo?',
    srs_next_level_example_1:
      "Se aggiungi una parola ai preferiti, sarà al livello 1. Una parola al livello 1 passerà al livello successivo se è passato 1 giorno da quando l'hai aggiunta, il tuo tasso di successo è superiore al 50% e hai appena ricordato correttamente la parola.",
    srs_next_level_example_2:
      "Una parola al livello {level} passerà al livello successivo dopo che l'ultimo cambiamento al livello {levelM1} è stato almeno {days} giorni fa, il tuo tasso di successo è superiore al 50% e hai appena ricordato correttamente la parola.",
    favorite_group: 'Gruppe',
    group_already_exists: 'Una cartella con questo nome esiste già',
    cannot_delete_default: 'La cartella `Default` non può essere eliminata',
    group_still_has_words:
      'La cartella contiene ancora preferiti. Per favore elimina prima tutti i preferiti.',
    group_deleted: 'Cartella eliminata'
  },
  player: {
    maximize: 'Massimizza',
    minimize: 'Minimizza'
  },
  video: {
    error:
      'Si è verificato un errore durante il caricamento dei sottotitoli. Sfortunatamente non tutti i sottotitoli sono liberamente accessibili. Per favore prova un altro video.'
  },
  feeds: {
    disclaimer:
      "Questo è un riassunto generato automaticamente da Chatgpt. L'articolo originale è disponibile",
    here: 'qui',
    generating_article: 'Generazione articolo...',
    error:
      "Si è verificato un errore durante il caricamento dell'articolo. Purtroppo non tutti gli articoli sono liberamente accessibili. Prova un altro articolo o copia il testo manualmente",
    open_org: '1. Apri articolo originale e copia il testo',
    open_own: '2. Incolla il testo qui'
  },
  books: {
    read_now: 'Leggi ora',
    continue_on_page: 'Continua sulla pagina'
  },
  tooltip: {
    examples: 'Esempi',
    emotional_examples: 'Esempi emotivi',
    definition: 'Definizione',
    base_word: 'Forma base',
    synonyms: 'Sinonimi',
    antonyms: 'Contrari',
    article: 'Articolo',
    conjugations: 'Coniugazione',
    grammer: 'Grammatica',
    etymology: 'Etimologia',
    all_meanings: 'Tutti i significati',
    context: 'Contesto'
  },
  custom_text: {
    enter_your_own_text: 'Inserisci il tuo testo',
    read_text: 'Leggi il testo',
    enter_new_text: 'Inserisci un nuovo testo',
    own_text: 'Copia il tuo testo e incollalo qui',
    special_vocabulary: 'Vocabolario speciale'
  },
  special_vocabulary: {
    special_vocabulary: 'Vocabolario speciale',
    explanation:
      'Qui puoi creare un nuovo testo su un argomento che vorresti studiare. Verrà generato un testo che potrai usare per studiare.',
    describe:
      'Inserisci un testo in inglese su un argomento o vocabolario speciale che vuoi imparare',
    language_level: 'Livello linguistico',
    generate_text: 'Genera testo'
  },
  custom_vocabulary: {
    custom_vocabulary: 'Vocabolario personalizzato',
    add_new_category: 'Aggiungi nuova categoria',
    title: 'Titolo',
    description: 'Quale vocabolario vuoi imparare?',
    description_placeholder: 'Descrivi il vocabolario che vuoi imparare',
    description_example: "Esempio: 'Numeri da 1 a 20'",
    number_of_words: 'Numero di vocaboli',
    generate: 'Genera',
    no_lists_found: 'Nessuna lista di vocabolario personalizzato ancora',
    list_not_found: 'Questa lista di vocabolario non è stata trovata',
    error_generating: 'Si è verificato un errore durante la generazione del vocabolario. Riprova.',
    home_teaser: 'Crea le tue liste di vocabolario su qualsiasi argomento tu voglia imparare',
    n_lists: 'lista personalizzata | liste personalizzate'
  },
  live_conversations: {
    start_conversation: 'Inizia conversazione',
    end_conversation: 'Termina conversazione',
    connecting: 'Connessione in corso…',
    connected: 'Conversazione in corso…',
    microphone_error:
      "Impossibile avviare la conversazione. Controlla l'accesso al microfono e riprova.",
    not_found: 'Questa conversazione non è stata trovata',
    reviewing: 'Analisi della tua conversazione…',
    transcript_title: 'La tua conversazione',
    no_turns: 'Nessuna conversazione è stata registrata.',
    no_mistakes: 'Nessun errore trovato, ottimo lavoro!',
    review_unavailable: "Impossibile caricare l'analisi. Riprova più tardi."
  },
  intro_message: {
    save_word_as_fav: 'Clicca sulla stella per salvare la parola come preferita',
    save_video_as_fav: 'Clicca sulla stella per salvare il video come preferito',
    save_article_as_fav: "Clicca sulla stella per salvare l'articolo come preferito",
    save_book_as_fav: 'Clicca sulla stella per salvare il libro come preferito',
    save_wordmap_as_fav: 'Clicca sulla stella per salvare la mappa delle parole come preferita',
    play_word: 'Clicca sul pulsante play per ascoltare la pronuncia della parola',
    play_article: "Clicca sul pulsante play per ascoltare l'articolo",
    play_book: 'Clicca sul pulsante play per ascoltare il libro',
    select_main_category: 'Seleziona una categoria principale',
    select_sub_category: 'Seleziona una sottocategoria',
    click_on_read: 'Clicca su `LEGGI` per leggere il testo completo',
    click_on_view: 'Clicca su `GUARDA` per guardare un video',
    wordmap_click_on_word: 'Clicca sulla parola per vedere le parole più usate',
    wordmap_click_on_line: 'Clicca su una linea tra due parole per vedere una frase',
    conversations_select_scene: 'Seleziona un esercizio',
    conversations_warn:
      'Sembra che ci sia un errore nella tua frase. Clicca sul triangolo per maggiori spiegazioni.',
    conversations_task: 'Formula una frase basandoti sulle seguenti istruzioni:'
  },
  tour_guide: {
    click_on_every_word: {
      title: 'Traduci parola',
      text: 'Puoi cliccare su qualsiasi parola per vedere traduzioni, frasi di esempio e definizioni'
    },
    click_on_i_for_sentence: {
      title: 'Intera frase',
      text: 'Per tradurre un`intera frase, clicca sul simbolo i. Qui puoi anche ottenere spiegazioni sulla grammatica.'
    },
    no_save_custom: {
      title: 'Impossibile salvare',
      text: 'Non è possibile salvare i testi personali'
    },
    change_playback_rate: {
      title: 'Modifica la Velocità di Riproduzione',
      text: 'Modifica la velocità di riproduzione tramite Menu/Impostazioni/Audio e Video.'
    },
    theme: {
      title: 'Colori',
      text: 'Puoi cambiare i colori nel menu alla modalità scura'
    },

    repeat_words: {
      title: 'Ripeti il vocabolario',
      text: 'Dovresti ripetere {nWords} vocaboli.',
      call_to_action: 'Impara ora'
    },
    flipcards: {
      title: 'Carte',
      text: 'Gira la carta e clicca sul volto felice o triste per tenere traccia dei tuoi progressi'
    },
    synapsis_score: {
      title: 'Punteggio Synapsis',
      text: 'Guadagni punti per ogni parola, ponderati per il suo livello, e punti aggiuntivi per ogni capitolo o unità completata'
    }
  },
  chat: {
    your_message: 'Il tuo messaggio',
    waiting_for_teacher: "In attesa dell'insegnante...",
    in_de: 'in tedesco',
    in_en: 'in inglese',
    in_es: 'in spagnolo',
    in_fr: 'in francese',
    in_pt: 'in portoghese',
    in_ru: 'in russo',
    in_zh: 'in cinese',
    in_pl: 'in polacco',
    wait: 'Attendere prego...',
    speak_now: 'Parla ora',
    new_chat: 'Nuova chat',
    switch_language: 'Cambia lingua',
    language_teacher: 'Insegnante di lingue',
    summarize_mistakes: 'Riassumi gli errori'
  },
  langs: {
    de: 'Tedesco',
    en: 'Inglese',
    es: 'Spagnolo',
    fr: 'Francese',
    it: 'Italiano',
    pt: 'Portoghese',
    ru: 'Russo',
    zh: 'Cinese',
    pl: 'Polacco'
  },
  countries: {
    de: 'Germania',
    en: 'Inghilterra',
    es: 'Spagna',
    fr: 'Francia',
    it: 'Italia',
    pt: 'Portogallo',
    ru: 'Russia',
    pl: 'Polonia',
    zh: 'Cina'
  },
  about: {
    how_does_it_work: 'Come funziona?',
    here_you_can: 'Qui puoi',
    read_texts: 'leggere testi',
    watch_videos: 'guardare video',
    click_on_every_wrord_for: 'Clicca su una parola per',
    translations: 'traduzioni',
    examples: 'esempi',
    definitions: 'definizioni',
    synonyms: 'sinonimi',
    copy_your_own_text: 'Copiare e leggere i tuoi testi',
    chat_with_chatbot: 'Chatta con un chatbot',
    level: 'Il tuo livello dovrebbe essere tra B1 e C2'
  },
  settings: {
    audio_video: 'Audio e Video',
    level: 'Livello',
    colors: 'Colore',
    dark_mode: 'Modalità scura',
    lang_level: 'Livello di lingua',
    show_pinyin: 'Mostra pinyin',
    show_translation: 'Mostra traduzione'
  },
  error: {
    resource_not_found: 'Siamo spiacenti, non siamo riusciti a trovare quello che stai cercando'
  },
  train: {
    check: 'Controlla',
    flashcards: 'Flashcard',
    exercises: 'Esercizi',
    finished: 'Esercizi completati',
    go_to_favorites: 'Vai ai preferiti',
    restart_exercise: 'Ricomincia esercizio',
    go_to_home: 'Vai alla home',
    text_with_words: 'Testo con parole',
    text_includes: 'Il testo include tutte le parole che vuoi imparare',
    generate_audio: 'Genera audio',
    stop_audio: 'Interrompi audio'
  },
  wordmap: {
    click_on_circle: 'Clicca sul cerchio per vedere le parole più frequentemente usate con {word}',
    click_on_edge: 'Clicca sulla linea tra due parole per vedere una frase con entrambe le parole',
    open_fullscreen: 'Apri a schermo intero',
    add_own_word: 'Aggiungi parola personale',
    add_sentence_with_all_words: 'Aggiungi frase con tutte le parole',
    add_to_word: 'Aggiungi alla parola'
  },
  conversations: {
    you_are: 'Tu sei',
    you_talk_to: 'Tu parli con',
    your_tasks: 'I tuoi compiti'
  },
  write: {
    min_words: 'Parole minime',
    your_email_needs_to_contain: 'La tua email deve contenere',
    rate: 'Valutazione',
    analysis: 'Analisi',
    overall: 'Generale',
    grammar: 'Grammatica',
    content: 'Contenuto',
    spelling: 'Ortografia',
    passed: 'Ottimo lavoro! Hai superato questo esercizio.',
    failed: 'Continua a praticare! Il tuo punteggio non è stato sufficiente per passare.',
    restart: 'Riprova'
  },
  cookies: {
    title: 'This website uses cookies',
    description:
      "We use cookies to personalise content and ads, to provide social media features and to analyse our traffic. We also share information about your use of our site with our social media, advertising and analytics partners who may combine it with other information that you've provided to them or that they've collected from your use of their services.",
    description_short:
      'We use cookies to personalise content and ads, to provide social media features and to analyse our traffic...',
    deny: 'Deny',
    allow_selection: 'Allow selection',
    clear_local_storage: 'Clear local storage keys',
    clear_local_storage_confirm: 'Are you sure you want to remove selected local storage keys?',
    clear_local_storage_success: 'Selected local storage keys have been removed.',
    tooltip_necessary:
      'Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.',
    tooltip_preferences:
      'Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in.',
    tooltip_statistics:
      'Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.',
    tooltip_marketing:
      'Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.'
  },
  grammar: {
    start_grammar_lessons: 'Inizia le lezioni di grammatica'
  },
  transcription: {
    title: 'Trascrizione dal vivo',
    subtitle: 'Ascolta una conversazione e vedila scritta sullo schermo mentre parli',
    start: 'Avvia trascrizione',
    stop: 'Ferma',
    listening: 'In ascolto…',
    transcribing: 'Trascrizione in corso…',
    mic_settings_title: 'Impostazioni microfono',
    mic_mode_close: 'Voce vicina',
    mic_mode_distant: 'Distante / riproduzione audio',
    mic_boost_label: 'Amplificazione microfono',
    mic_settings_hint: 'Verrà applicato al prossimo avvio',
    mic_level_label: 'Livello di ingresso del microfono',
    mic_level_clipping: 'Troppo forte',
    mic_test_start: 'Testa microfono',
    mic_test_stop: 'Interrompi test',
    empty_state:
      'Tocca "Avvia trascrizione" e inizia a parlare: quello che viene detto apparirà qui',
    not_supported:
      "La trascrizione dal vivo non è supportata da questo browser. Assicurati che l'accesso al microfono sia disponibile.",
    microphone_error:
      'Impossibile accedere al microfono. Controlla i permessi del microfono e riprova.',
    transcription_error: 'Impossibile trascrivere quella parte. Ascolto ancora in corso…',
    copied: 'Trascrizione copiata negli appunti'
  },
  video_object_detection: {
    title: 'Rilevamento Oggetti Video',
    subtitle:
      'Punta la fotocamera verso gli oggetti intorno a te e scopri come si chiamano nella lingua che stai imparando',
    start: 'Avvia Video',
    stop: 'Ferma',
    scanning: 'Scansione in corso…',
    empty_state:
      'Tocca "Avvia Video" e punta la fotocamera verso gli oggetti per vederli etichettati qui',
    not_supported:
      "L'accesso alla fotocamera non è supportato in questo browser. Prova con Chrome o Edge.",
    camera_error:
      'Impossibile accedere alla fotocamera. Controlla le autorizzazioni della fotocamera e riprova.',
    detected_words: 'Parole rilevate',
    nearby_objects: 'Altri oggetti nelle vicinanze: tocca per aggiungere'
  }
};
